import {IFluxStandardAction} from "@fkhplus/common/src/modules/interfaces";
import {ThemeActionTypes, ThemePayload} from "@fkhplus/common/src/modules/theme/actions";
import {IThemeResponse} from "@fkhplus/common/src/modules/theme/interface";
import BaseTheme from "@fkhplus/common/src/styles/themes/Base";

export const initialState: IThemeResponse = {
    theme: BaseTheme,
};

export const ThemeReducer = (
    state: IThemeResponse = initialState,
    action: IFluxStandardAction<ThemePayload>): IThemeResponse => {
    switch (action.type) {
        case ThemeActionTypes.SWITCH_SUCCESS :
            return {
                ...state,
                theme: action.payload
            };
        default:
            return state;
    }
};